// libs
import { useState } from "react";
import { Plus, Package } from "lucide-react";

// components
import CreateProduct from "../../components/CreateProduct";
import ProductsList from "../../components/ProductsList";
import CustomButton from "../../components/CustomButton";
import NoAccess from "../../components/NoAccess";

// hooks
import useUserData from "../../hooks/useUserData";

// styles
import classes from "./styles.module.css";

export default function ProductsPage() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { isAdmin } = useUserData();

  const addNewProduct = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headText}>
          <Package stroke="#009966" />
          <p>Складской учёт</p>
        </div>

        {isAdmin && (
          <CustomButton onClick={addNewProduct} className={classes.addButton}>
            <Plus size={15} />
            Добавить
          </CustomButton>
        )}
      </div>

      {isAdmin ? (
        <>
          <ProductsList />
          {isOpenModal && <CreateProduct onCloseModal={closeModal} />}
        </>
      ) : (
        <NoAccess />
      )}
    </div>
  );
}
